"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionScopes = void 0;
var PermissionScopes;
(function (PermissionScopes) {
    PermissionScopes["userRead"] = "user.read";
    PermissionScopes["userCreate"] = "user.create";
    PermissionScopes["userUpdate"] = "user.update";
    PermissionScopes["organizationAccessAll"] = "organization.accessAll";
    // organizationRead = 'organization.read',
    // organizationCreate = 'organization.create',
    // organizationUpdate = 'organization.update',
    // organizationDelete = 'organization.delete',
    PermissionScopes["eventRead"] = "event.read";
    // eventCreate = 'event.create',
    // eventUpdate = 'event.update',
    // eventDelete = 'event.delete',
    // eventCopy = 'event.copy',
    // eventActivate = 'event.activate',
    PermissionScopes["orderRead"] = "order.read";
    // orderCreate = 'order.create',
    // orderUpdate = 'order.update',
    // orderDelete = 'order.delete',
    PermissionScopes["ticketRead"] = "ticket.read";
    // ticketCreate = 'ticket.create',
    // ticketUpdate = 'ticket.update',
    // ticketDelete = 'ticket.delete',
    // deviceRead = 'device.read',
    // deviceCreate = 'device.create',
    // deviceUpdate = 'device.update',
    // deviceDelete = 'device.delete',
    // customerRead = 'customer.read',
    // customerCreate = 'customer.create',
    // customerUpdate = 'customer.update',
    // customerDelete = 'customer.delete',
    // prizeRead = 'prize.read',
    // prizeCreate = 'prize.create',
    // prizeUpdate = 'prize.update',
    // prizeDelete = 'prize.delete',
    // salesRepRead = 'salesRep.read'
    // salesRepCreate = 'salesRep.create',
    // salesRepUpdate = 'salesRep.update',
    // salesRepDelete = 'salesRep.delete'
})(PermissionScopes = exports.PermissionScopes || (exports.PermissionScopes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGVybWlzc2lvbi1zY29wZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbW9kZWxzL3Blcm1pc3Npb24tc2NvcGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksZ0JBK0NYO0FBL0NELFdBQVksZ0JBQWdCO0lBQzFCLDBDQUFzQixDQUFBO0lBQ3RCLDhDQUEwQixDQUFBO0lBQzFCLDhDQUEwQixDQUFBO0lBRTFCLG9FQUFnRCxDQUFBO0lBQ2hELDBDQUEwQztJQUMxQyw4Q0FBOEM7SUFDOUMsOENBQThDO0lBQzlDLDhDQUE4QztJQUU5Qyw0Q0FBd0IsQ0FBQTtJQUN4QixnQ0FBZ0M7SUFDaEMsZ0NBQWdDO0lBQ2hDLGdDQUFnQztJQUNoQyw0QkFBNEI7SUFDNUIsb0NBQW9DO0lBRXBDLDRDQUF3QixDQUFBO0lBQ3hCLGdDQUFnQztJQUNoQyxnQ0FBZ0M7SUFDaEMsZ0NBQWdDO0lBRWhDLDhDQUEwQixDQUFBO0lBQzFCLGtDQUFrQztJQUNsQyxrQ0FBa0M7SUFDbEMsa0NBQWtDO0lBRWxDLDhCQUE4QjtJQUM5QixrQ0FBa0M7SUFDbEMsa0NBQWtDO0lBQ2xDLGtDQUFrQztJQUVsQyxrQ0FBa0M7SUFDbEMsc0NBQXNDO0lBQ3RDLHNDQUFzQztJQUN0QyxzQ0FBc0M7SUFFdEMsNEJBQTRCO0lBQzVCLGdDQUFnQztJQUNoQyxnQ0FBZ0M7SUFDaEMsZ0NBQWdDO0lBRWhDLGlDQUFpQztJQUNqQyxzQ0FBc0M7SUFDdEMsc0NBQXNDO0lBQ3RDLHFDQUFxQztBQUN2QyxDQUFDLEVBL0NXLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBK0MzQiJ9